import type { ShapeData } from '@/lib/shapes/types/shape-data'
import type { ShapeManagerRef } from '@/lib/shapes/types/shape-manager-ref'

export type LiveSelection = {
  allShapes: ShapeData[]
  selectedShapes: ShapeData[]
}

/**
 * Live read of the manager's own selected ids (visible shapes only, in selection order) instead of
 * the activeObjects context — that context can go stale for some selection paths while the
 * manager's own selected-ids stay accurate. A selected text frame is a shape now
 * (text-unification) and already appears in `selectedShapes` — there is no separate text
 * population left to read.
 */
export function readLiveSelection(mgr: ShapeManagerRef | null | undefined): LiveSelection {
  const allShapes = mgr?.getShapes() ?? []
  const shapeIds = mgr?.getSelectedShapeIds() ?? []
  const selectedShapes = shapeIds
    .map((id) => allShapes.find((s) => s.id === id))
    .filter((s): s is ShapeData => s != null && s.hidden !== true)

  return { allShapes, selectedShapes }
}
